import script from "./ExamEvaluation.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamEvaluation.vue?vue&type=script&setup=true&lang=ts"

import "./ExamEvaluation.vue?vue&type=style&index=0&id=41e5272e&lang=scss"

const __exports__ = script;

export default __exports__